/**
 * NodeList compatible addEventListener.
 *
 * @param {string} event
 * @param {function} callback
 * @returns {NodeList}
 */
NodeList.prototype.addEventListener = function (event, callback) {
    if (!this.length) return this;

    if (typeof callback !== 'function') {
        console.warn('callback parameter is not a function');
    }

    this.forEach(el => el.addEventListener(event, callback));
    return this;
}
